// import db from '../../firebase/firebaseInit';
import firebase from "firebase"
const functions = firebase.functions()

export default {
  state: {
    emailPopup: {
      visible: false,
      data: {
        sendToId: "vaneijkchris@gmail.com"
      }
    }
  },
  getters: {
    emailPopupVisible(state) {
      return state.emailPopup.visible
    },
    emailInfo(state) {
      return state.emailPopup.data
    }
  },
  mutations: {
    SET_EMAILPOPUP_VISIBILITY(state, value) {
      state.emailPopup.visible = value
    },
    SET_EMAILDATA_SENDTOID(state, value) {
      state.emailPopup.data.sendToId = value
    }
  },
  actions: {
    //Email versturen
    async sendRegularEmail(context, payload) {
      const callable = functions.httpsCallable("verstuurStandaardEmail")
      return callable({
        body: payload.bodyTekst,
        subject: payload.subjectTekst,
        sendTo: payload.sendToEmail
      }).then(() =>
        // do something here
        alert("email succesvol verstuurd")
      )
    }
  }
}
